import type { ReactNode } from 'react';

import { Navigate, useLocation } from 'react-router';

import * as utils from '../../shared/utils';

const AuthRoute = ({ children }: { children: ReactNode }) => {
  const location = useLocation();
  const hasToken = utils.isTokenExist();

  return hasToken ? <Navigate to="/" state={{ from: location }} /> : children;
};
export default AuthRoute;
